module.exports = __webpack_public_path__ + "img/png.100677bb.png";